export const defaultInputValidationPaneInvalidInputErrorMessageStyles = {
  color: "#a4262c",
  fontFamily: "'Segoe UI', Arial, sans-serif",
  fontSize: "12px",
  height: "16px",
  lineHeight: "16px",
  marginTop: "4px"
};